import React, { useState, useEffect, useRef } from 'react';
import './App.css';

function App() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const content = {
    name: 'Mequanent Seifu Gebremichael',
    title: 'Senior IT Educator & Technical Consultant',
    location: 'Addis Ababa, Ethiopia',
    phone: '+251941554818',
    email: 'ethiomk@elcotech.org',
    linkedin: 'linkedin.com/in/mequanent-seifu',
    
    welcome: 'Transforming Tech Education Through Innovation',
    description: '17+ years of expertise in ICT instruction, advanced computer systems, and curriculum development. Bridging theory with industry practice.',
    
    about: 'Professional Profile',
    aboutText: `🎓 MSc in Information Technology Technical Teacher Education 

🌐 Online Engagement: Provide online guidance and learning support for students in ICT-related subjects.

🏛️ Government Service: ICT educator in higher education.

💡 Specializing in advanced IT education, Educational program development, and technical consultation with deep industry experience across multiple sectors.

🌍 Languages: Amharic (Native), English (Fluent), Chinese (Basic), Sign Language (Conversational)`,

    services: 'Expert IT Services',
    servicesList: [
      ['Advanced Computer Training', 'Comprehensive training in programming, databases, networking, and software development for all skill levels.'],
      ['Web Design & Development', 'Full-stack web development using modern frameworks (React, PHP) with responsive design principles.'],
      ['Advanced Computer Maintenance & Networking', 'Enterprise-level hardware troubleshooting, Cisco network scaling, and IT infrastructure management.'],
      ['Bot Development & Automation', 'Custom bot development for process automation, data processing, and intelligent systems.'],
      ['Educational framework development', 'Designing cutting-edge IT education programs aligned with industry standards and technological trends.'],
      ['Technical Consultation', 'Expert guidance on IT infrastructure, system optimization, and digital transformation strategies.']
    ],

    education: 'Education & Certifications',
    educationList: [
      ['MSc in Information Technology Technical Teacher Education', 'FTTI'],
      ['BSc in Technical Teacher Education (IT)', 'Ethio-China University '],
      ['Diploma in Special Needs and Language', 'KCTE'],
      ['Diploma, IT Technician', 'Nefassilk Poly-Technic College'],
      ['Coursework in Business Administration', 'Adama Science and Technology University']
    ],

    certifications: [
      'Wholistic Certificate of Competence in IT Support Level 4',
      'CISCO Scaling Networks Certification','Wholistic Certificate of Competence in Hardware and Network Service Level 5',
      'Advanced Pedagogical Methods Certification'
    ],

    technicalSkills: 'Technical Expertise',
    skillsList: [
      ['Programming & Development', 'Java, C++, C#, PHP, Visual Basic, SQL, React, QBASIC'],
      ['Database Management', 'Oracle, MySQL, Supabase, SQL Server'],
      ['Networking & Infrastructure', 'Cisco Scaling Networks, Network Maintenance, CSMARP(CR)'],
      ['Software & Systems', 'Adobe Photoshop, Macromedia Suite, Microsoft Office Suite'],
      ['IT Support & Maintenance', 'Advanced Computer Maintenance, Hardware Troubleshooting']
    ]
  };

  // Animation observer for service cards
  const [visibleCards, setVisibleCards] = useState([]);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = entry.target.dataset.index;
            setVisibleCards((prev) => [...new Set([...prev, index])]);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -50px 0px' }
    );

    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      service: formData.get('service'),
      message: formData.get('message'),
      _subject: `New Inquiry from ${formData.get('name')}`,
      _captcha: "false"
    };

    try {
      const response = await fetch('https://formsubmit.co/ajax/ethiomk@elcotech.org', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();
      
      if (result.success) {
        setSubmitMessage('✅ Thank you! Your message has been sent successfully. I will respond within 24-48 hours.');
        e.target.reset();
      } else {
        setSubmitMessage('⚠️ There was an error sending your message. Please try again or email directly at ethiomk@elcotech.org');
      }
    } catch (error) {
      console.error('Error:', error);
      setSubmitMessage('❌ Network error. Please try again or contact directly via phone.');
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitMessage(''), 5000);
    }
  };

  return (
    <div className="App">
      <style>
        {`
          /* ========== READABLE & CLICKABLE CEO LINK ========== */
          .logo-link {
            position: relative;
            display: inline-block;
            text-decoration: none;
            font-weight: 800;
            letter-spacing: 0.03em;
            font-size: 1.35rem;
            padding: 0.6rem 1.8rem;
            border-radius: 60px;
            /* Glass-morphism with high transparency for readability */
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.3);
            color: #1a2a3a;
            text-shadow: 0 1px 2px rgba(255,255,255,0.5);
            transition: all 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
            box-shadow: 0 6px 14px rgba(0,0,0,0.1), 0 0 0 1px rgba(255,255,255,0.2) inset;
            animation: gentlePulse 2.5s infinite ease-in-out;
          }
            
          @keyframes gentlePulse {
            0% {
              box-shadow: 0 6px 14px rgba(0,0,0,0.1), 0 0 0 1px rgba(255,255,255,0.2) inset;
              transform: scale(1);
            }
            50% {
              box-shadow: 0 12px 24px rgba(0,0,0,0.15), 0 0 0 2px rgba(255,215,0,0.5) inset;
              transform: scale(1.02);
            }
            100% {
              box-shadow: 0 6px 14px rgba(0,0,0,0.1), 0 0 0 1px rgba(255,255,255,0.2) inset;
              transform: scale(1);
            }
          }

          .logo-link::before {
            content: '';
            position: absolute;
            bottom: 6px;
            left: 20%;
            width: 60%;
            height: 2px;
            background: linear-gradient(90deg, #ff8c00, #ff2e63, #8a2387);
            border-radius: 4px;
            transition: width 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94), left 0.4s ease;
            box-shadow: 0 0 6px rgba(255, 44, 99, 0.6);
            opacity: 0.8;
          }

          .logo-link::after {
            content: '✨';
            position: absolute;
            right: 18px;
            top: 50%;
            transform: translateY(-50%) scale(0.85);
            opacity: 0.7;
            transition: all 0.3s ease;
            font-size: 1rem;
            filter: drop-shadow(0 0 2px gold);
          }

          .logo-link:hover {
            transform: translateY(-3px) scale(1.03);
            background: rgba(255, 255, 255, 0.35);
            border-color: rgba(255, 215, 0, 0.6);
            box-shadow: 0 16px 28px rgba(0,0,0,0.2), 0 0 0 2px rgba(255,255,255,0.4) inset;
            color: #1f2c3c;
            text-shadow: 0 1px 3px rgba(255,255,255,0.8);
            letter-spacing: 0.04em;
            animation: none;
          }

          .logo-link:hover::before {
            width: 80%;
            left: 10%;
            background: linear-gradient(90deg, #ffcc00, #ff2e63, #ff8c00, #ffcc00);
            background-size: 200% auto;
            animation: shimmer 1.2s linear infinite;
            opacity: 1;
          }

          .logo-link:hover::after {
            opacity: 1;
            transform: translateY(-50%) scale(1.1);
            right: 12px;
          }

          @keyframes shimmer {
            0% { background-position: 0% 0; }
            100% { background-position: 200% 0; }
          }

          .logo-link:active {
            transform: scale(0.97);
            transition: 0.05s;
          }

          /* All other existing styles remain untouched */
          .contact-form select {
            width: 100%;
            padding: 14px 18px;
            font-size: 1rem;
            font-family: inherit;
            border: none;
            border-radius: 16px;
            background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
            color: #2d1b4e;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 8px 20px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.5);
            appearance: none;
            -webkit-appearance: none;
            background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%236b21a8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>");
            background-repeat: no-repeat;
            background-position: right 18px center;
            background-size: 20px;
          }
          .contact-form select option {
            background: #fff0e0;
            color: #2c1a4a;
            padding: 12px;
            font-weight: 500;
            text-shadow: none;
          }
          .contact-form select:hover {
            transform: translateY(-2px);
            box-shadow: 0 14px 28px rgba(0,0,0,0.15);
            background: linear-gradient(135deg, #ffe6b3, #ffaa80);
          }
          .contact-form select:focus {
            outline: none;
            box-shadow: 0 0 0 4px rgba(255, 140, 0, 0.4), 0 8px 20px rgba(0,0,0,0.1);
            transform: scale(1.01);
            background: linear-gradient(135deg, #ffe0b5, #ffb347);
          }
          .contact-form select:active {
            transform: scale(0.98);
            transition: 0.05s;
          }
          .contact-form select option:hover {
            background: linear-gradient(90deg, #ff9966, #ff5e62);
            color: white;
            padding-left: 20px;
          }

          .service-card {
            opacity: 0;
            transform: translateY(30px);
            transition: opacity 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1), transform 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1);
            will-change: transform, opacity;
          }
          .service-card.visible {
            opacity: 1;
            transform: translateY(0);
          }
          .service-card:hover {
            transform: translateY(-8px) scale(1.02);
            transition: transform 0.3s ease, box-shadow 0.3s;
            box-shadow: 0 20px 35px -12px rgba(0,0,0,0.2);
          }
          .service-card .card-icon {
            transition: transform 0.3s ease;
          }
          .service-card:hover .card-icon {
            transform: scale(1.2) rotate(5deg);
          }
          .service-card:nth-child(1) { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
          .service-card:nth-child(2) { background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); }
          .service-card:nth-child(3) { background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); }
          .service-card:nth-child(4) { background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%); }
          .service-card:nth-child(5) { background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); }
          .service-card:nth-child(6) { background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%); }
          .service-card {
            border-radius: 28px;
            padding: 1.8rem;
            color: white;
            text-shadow: 0 1px 2px rgba(0,0,0,0.2);
          }
          .service-card h3, .service-card p {
            color: white;
          }
          .service-card p {
            opacity: 0.95;
          }
        `}
      </style>
      <header>
        <nav>
          <a 
            href="https://www.elcotech.org" 
            className="logo logo-link" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="CEO of ELCOTECH - visit official company website"
            title="Visit ELCOTECH official website"
          >
            C̤E̤O̤ o̤f̤ E̤L̤C̤O̤T̤E̤C̤H̤
          </a>
          <ul>
            <li><a href="#about">Profile</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#education">Education</a></li>
            <li><a href="#skills">Expertise</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
      </header>
      
      <main>
        <section className="hero">
          <div className="hero-content">
            <div className="hero-title">
              <h1>{content.name}</h1>
              <div className="title-gradient">{content.title}</div>
            </div>
            <p className="hero-subtitle">{content.welcome}</p>
            <p className="hero-description">{content.description}</p>
            
            <div className="contact-info-header">
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>{content.location}</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <a href={`tel:${content.phone}`} className="contact-link">{content.phone}</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <a href={`mailto:${content.email}`} className="contact-link">{content.email}</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">🔗</span>
                <a href={`https://${content.linkedin}`} target="_blank" rel="noopener noreferrer" className="contact-link">LinkedIn Profile</a>
              </div>
            </div>
            
            <div className="hero-buttons">
              <a href="#services" className="cta-button primary">Explore Services</a>
              <a href="#contact" className="cta-button secondary">Contact Me</a>
            </div>
          </div>
        </section>

        <section className="section" id="about">
          <h2><span className="section-icon">👨‍💼</span> {content.about}</h2>
          <div className="profile-card">
            <div className="profile-content">
              <p style={{ whiteSpace: 'pre-line' }}>{content.aboutText}</p>
              <div className="experience-badge">
                <span className="experience-number">17+</span>
                <span className="experience-text">Years Experience</span>
              </div>
            </div>
          </div>
        </section>

        <section className="section-dark" id="services">
          <h2><span className="section-icon">🚀</span> {content.services}</h2>
          <div className="grid">
            {content.servicesList.map(([title, text], i) => (
              <div 
                className={`card service-card ${visibleCards.includes(i.toString()) ? 'visible' : ''}`}
                key={i}
                ref={(el) => (cardsRef.current[i] = el)}
                data-index={i}
              >
                <div className="card-icon">{['💻', '🌐', '🔧', '🤖', '📚', '💡'][i]}</div>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="section" id="education">
          <div className="two-column">
            <div className="column">
              <h2><span className="section-icon">🎓</span> Education</h2>
              <div className="timeline">
                {content.educationList.map(([degree, details], i) => (
                  <div className="timeline-item" key={i}>
                    <div className="timeline-dot"></div>
                    <div className="timeline-content">
                      <h4>{degree}</h4>
                      <p>{details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="column">
              <h2><span className="section-icon">📜</span> Certifications</h2>
              <div className="certifications-list">
                {content.certifications.map((cert, i) => (
                  <div className="certification-item" key={i}>
                    <span className="cert-icon">✅</span>
                    <span>{cert}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="section-dark" id="skills">
          <h2><span className="section-icon">⚡</span> {content.technicalSkills}</h2>
          <div className="skills-grid">
            {content.skillsList.map(([category, skills], i) => (
              <div className="skill-category" key={i}>
                <h3>{category}</h3>
                <div className="skills-tags">
                  {skills.split(', ').map((skill, j) => (
                    <span className="skill-tag" key={j}>{skill}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="section" id="contact">
          <h2><span className="section-icon">📞</span> Contact me</h2>
          
          {submitMessage && (
            <div className={`alert-message ${submitMessage.includes('✅') ? 'success' : 'error'}`}>
              {submitMessage}
            </div>
          )}
          
          <div className="contact-grid">
            <div className="contact-info">
              <h3>Get in Touch</h3>
              <div className="contact-details">
                <div className="contact-detail-item">
                  <span className="detail-icon">📍</span>
                  <div>
                    <strong>Location</strong>
                    <p>{content.location}</p>
                  </div>
                </div>
                <div className="contact-detail-item">
                  <span className="detail-icon">📞</span>
                  <div>
                    <strong>Phone</strong>
                    <p><a href={`tel:${content.phone}`} className="contact-link">{content.phone}</a></p>
                  </div>
                </div>
                <div className="contact-detail-item">
                  <span className="detail-icon">✉️</span>
                  <div>
                    <strong>Email</strong>
                    <p><a href={`mailto:${content.email}`} className="contact-link">{content.email}</a></p>
                  </div>
                </div>
                <div className="contact-detail-item">
                  <span className="detail-icon">🔗</span>
                  <div>
                    <strong>LinkedIn</strong>
                    <p><a href={`https://${content.linkedin}`} target="_blank" rel="noopener noreferrer" className="contact-link">{content.linkedin}</a></p>
                  </div>
                </div>
              </div>
              
              <div className="availability">
                <h4>📅 Availability</h4>
                <p>• Flexible Consulting & Training Sessions</p>
                <p>• 🇪🇹 Ethiopia 🇪🇹</p>
                <p>• Online & On-site (Addis Ababa)</p>
              </div>
            </div>
            
            <div className="contact-form-container">
              <form className="contact-form" onSubmit={handleSubmit}>
                <input 
                  type="text" 
                  name="name" 
                  placeholder="Full Name"
                  required 
                />
                <input 
                  type="email" 
                  name="email" 
                  placeholder="Email Address"
                  required 
                />
                <select name="service" required>
                  <option value="">✨ Select a service ✨</option>
                  <option value="training">💻 Advanced Computer Training</option>
                  <option value="web">🌐 Web Design & Development</option>
                  <option value="maintenance">🔧 Computer Maintenance & Networking</option>
                  <option value="bots">🤖 Bot Development</option>
                  <option value="consultation">💡 Technical Consultation</option>
                  <option value="other">📚 Other Inquiry</option>
                </select>
                <textarea
                  name="message"
                  placeholder="Describe your project or training needs..."
                  required
                  rows="6"
                ></textarea>
                <button type="submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send Professional Inquiry'}
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>
      
      <footer className="footer">
        <div className="footer-content">
          <p>© {new Date().getFullYear()}  🇮‌   🇦‌🇲‌   🇭‌🇪‌🇷‌🇪‌   🇫‌🇴‌🇷‌   🇾‌🇴‌🇺‌</p>
          <p className="footer-tagline">Transforming Technology Education in Ethiopia</p>
          <div className="footer-links">
            <a href={`mailto:${content.email}`}>Email</a>
            <a href={`tel:${content.phone}`}>Phone</a>
            <a href={`https://${content.linkedin}`} target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
